import script from "./ChatMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMenu.vue?vue&type=style&index=0&id=e6f0496c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6f0496c"]])

export default __exports__